import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import {
  ShimmerCss,
  ToggleCss,
  IconCss,
  TitleCss,
  SubTitleCss,
  Tags1Css,
  Tags2Css,
  TagsNumberCss,
  StatusCss,
  IconButtonCss,
} from './styles'

interface TableShimmerProps {
  hasType?: boolean
}

export const TableShimmer = ({ hasType }: TableShimmerProps) => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <Flex align={'center'}>
          <Box css={{ ...ShimmerCss, ...ToggleCss }}></Box>
          <Flex align={'center'}>
            <Box css={{ ...ShimmerCss, ...IconCss }}></Box>
            <Flex direction={'column'}>
              <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
              <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
            </Flex>
          </Flex>
        </Flex>
      </TableTd>
      {hasType && (
        <TableTd>
          <Flex align={'center'}>
            <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
            {!hasType && (
              <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
            )}
            <Box css={{ ...ShimmerCss, ...TagsNumberCss }}></Box>
          </Flex>
        </TableTd>
      )}
      <TableTd>
        <Flex align={'center'}>
          <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
          {!hasType && (
            <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
          )}
          <Box css={{ ...ShimmerCss, ...TagsNumberCss }}></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...StatusCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...TitleCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
